import React from 'react';
import { ImageSkeleton, LineSkeleton } from '../../Skeletons/skeletonTemplates';

export default function OverviewComponent(props) {
    if (props.data && props.data.content.length <= 0)
        return (<div></div>)
    return (
        <section className = "overview">
            <div className="container col-md-9">
                <h2 className ="font-weight-bold d-block d-sm-none mb-5">Course Overview</h2>
                <div className = "row">
                    <div className = "col-lg-4 col-12 custom-height my-auto">
                        {!props.data ?
                            <ImageSkeleton classes = "icon-size" />
                            :
                                <>
                                <img className = "img-fluid d-block d-sm-none mb-5 mx-auto course-landing-image" src = {props.data.overviewIcon} alt = "avtar"></img>
                                <img className = "img-fluid d-none d-sm-block course-landing-image" src = {props.data.overviewIcon} alt = "avtar"></img>
                                </>
                        }
                    </div>
                    <div className = "col-lg-8 col-12 text-left">
                        <h2 className ="font-weight-bold d-none d-sm-block text-left mb-4">Course Overview</h2>
                        {!props.data ? 
                            LineSkeleton(8)
                            :
                            <>
                                <div className = "text-muted d-none d-sm-block text-left urw-din text-lg overviewText" dangerouslySetInnerHTML={{ __html: props.data.content }} />
                                <div className = "text-muted d-block d-sm-none urw-din overviewText" dangerouslySetInnerHTML={{ __html: props.data.content }} />
                            </>
                        }
                    </div>
                </div>
            </div>
        </section>
    )
}